import React from "react";
import "./Order_details_table.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashCan } from "@fortawesome/free-solid-svg-icons";
import { Table, Form } from "react-bootstrap";
import { encodeId, variant_type, getVariantImage } from "../../../../utils/common";
import { Link } from "react-router-dom";

function Replace_Order_details_table({
  order,
  selectedItems,
  setSelectedItems,
  setError,
  setProductId,
  setShowReviewRating,
  showReviewRating,
  allorder,
}) {
  const handleCheckboxChange = (val) => {
    setError("");
    setSelectedItems((prev) => {
      const exists = prev.some((item) => item.id === val.id);
      if (exists) {
        return prev.filter((item) => item.id !== val.id);
      } else {
        return [...prev, val];
      }
    });
  };

  const handleOpenReview = async (productDetail) => {
    await setProductId(productDetail?.product_id);
    await setShowReviewRating(true);
  };
  return (
    <>
      <section className="Order_details_table Cart_Products_card d-none d-lg-block">
        <div className="inner_box_div">
          {order?.map((val) => (
            <div className="row align-items-center inner_card">
              <div className="col-sm-8 ">
                <Link
                  to={`/product-details/${encodeId(val?.Product?.id)}`}
                  className="text-decoration-none text-dark"
                >
                  <div className="row">
                    <div className="col-xxl-2 col-xl-3 col-lg-3 col-md-3 col-3">
                      <div className="img_holder">
                        <img
                          className="Product_img"
                          src={
                            getVariantImage(val)
                          }
                          alt="Product_img"
                        />
                      </div>
                    </div>

                    <div className="col-xxl-10 col-xl-9 col-lg-9 col-md-9 col-9">
                      <div className="info_text_holder">
                        <div>
                          <h4>{val?.Product?.name}</h4>
                          <div className="new">
                            {val?.Product?.variant_type_id ===
                              variant_type.Single && (
                              <>
                                {/* <>Variant :</>{" "} */}
                                <>
                                  <strong>
                                    {val?.Product?.variant_name} :{" "}
                                  </strong>
                                </>{" "}
                                {val?.Product_Variant?.Metal?.name}
                              </>
                            )}

                            {val?.Product?.variant_type_id ===
                              variant_type.Double && (
                              <>
                                {/* <>Variant :</>{" "} */}
                                <>
                                  <strong>
                                    {val?.Product?.variant_name} :
                                  </strong>
                                </>{" "}
                                {
                                  val?.Double_Variant?.Product_Variant?.Metal
                                    ?.name
                                }
                                <br></br>
                                <strong>Size :</strong>{" "}
                                {val?.Double_Variant?.Size?.name}{" "}
                              </>
                            )}

                            {val?.Product?.variant_type_id ===
                              variant_type.Triple && (
                              <>
                                {/* <>Variant :</>{" "} */}
                                <>
                                  <strong>
                                    {val?.Product?.variant_name} :
                                  </strong>
                                </>{" "}
                                {
                                  val?.Triple_Variant?.Double_Variant
                                    ?.Product_Variant?.Metal?.name
                                }
                                <br></br>
                                <strong>Size:</strong>{" "}
                                {
                                  val?.Triple_Variant?.Double_Variant?.Size
                                    ?.name
                                }
                                , <strong>Diamond:</strong>{" "}
                                {val?.Triple_Variant?.Diamond?.name}
                              </>
                            )}
                          </div>

                          {val?.Product_Variant?.name && (
                            <p className="mb-1">
                              <strong>Polish :</strong>{" "}
                              {val?.Product_Variant?.name}
                            </p>
                          )}

                          {val?.Double_Variant?.name && (
                            <p className="mb-1">
                              <strong>Colour :</strong>{" "}
                              {val?.Double_Variant?.name}
                            </p>
                          )}

                          {val?.Triple_Variant?.name && (
                            <p className="mb-1">
                              <strong>Size :</strong>{" "}
                              {val?.Triple_Variant?.name}
                            </p>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </Link>

             
              </div>

              <div className="col-sm-4 ">
                <div className="new_price_holder">
                  <div className="price_inner_text">
                    <p className="right_label">Price </p>
                    <p className="colon_text">:</p>₹
                    {allorder?.total_selling_price}
                  </div>

                  <div className="price_inner_text">
                    <p className="right_label">Order Qty </p>
                    <p className="colon_text">:</p>
                    {allorder?.no_of_item || 1}
                  </div>

                  <div className="price_inner_text">
                    <p className="right_label">Total Price </p>
                    <p className="colon_text">:</p>₹{" "}
                    {allorder?.no_of_item * allorder?.total_selling_price}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      <div className="d-block d-lg-none mobile_view_holder">
        {order?.map((val) => (
          <div className="mobile_product_card" key={val?.id}>
            <Link
              to={`/product-details/${val?.Product?.id}`}
              className="text-decoration-none text-dark"
            >
              <div className="order_holder">
                <div className="order_holder_left">
                  <div className="img_holder">
                    <img
                      className="Product_img"
                      src={getVariantImage(val)}
                      alt={val?.Product?.name}
                    />
                  </div>
                </div>

                <div className="order_holder_right">
                  <div className="descn_holder">
                    <div className="left_div">
                      <h6 className="product_name mb-2">
                        {val?.Product?.name}
                      </h6>

                      <div className="new">
                        {val?.Product?.variant_type_id ===
                          variant_type.Single && (
                          <>
                            {/* <>Variant :</>{" "} */}
                            <>
                              <strong>{val?.Product?.variant_name} : </strong>
                            </>{" "}
                            {val?.Product_Variant?.Metal?.name}
                          </>
                        )}

                        {val?.Product?.variant_type_id ===
                          variant_type.Double && (
                          <>
                            {/* <>Variant :</>{" "} */}
                            <>
                              <strong>{val?.Product?.variant_name} :</strong>
                            </>{" "}
                            {val?.Double_Variant?.Product_Variant?.Metal?.name}
                            <br></br>
                            <strong>Size :</strong>{" "}
                            {val?.Double_Variant?.Size?.name}{" "}
                          </>
                        )}

                        {val?.Product?.variant_type_id ===
                          variant_type.Triple && (
                          <>
                            {/* <>Variant :</>{" "} */}
                            <>
                              <strong>{val?.Product?.variant_name} :</strong>
                            </>{" "}
                            {
                              val?.Triple_Variant?.Double_Variant
                                ?.Product_Variant?.Metal?.name
                            }
                            <br></br>
                            <strong>Size:</strong>{" "}
                            {val?.Triple_Variant?.Double_Variant?.Size?.name},{" "}
                            <strong>Diamond:</strong>{" "}
                            {val?.Triple_Variant?.Diamond?.name}
                          </>
                        )}
                      </div>

                      {val?.Product_Variant?.name && (
                        <p className="mb-1">
                          <strong>Polish :</strong> {val?.Product_Variant?.name}
                        </p>
                      )}

                      {val?.Double_Variant?.name && (
                        <p className="mb-1">
                          <strong>Colour :</strong> {val?.Double_Variant?.name}
                        </p>
                      )}

                      {val?.Triple_Variant?.name && (
                        <p className="mb-1">
                          <strong>Size :</strong> {val?.Triple_Variant?.name}
                        </p>
                      )}
                    </div>

                    <div className="price_details">
                      <p className="mb-1">
                        <strong>₹ {allorder?.total_selling_price}</strong> X  {allorder?.no_of_item || 1}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </Link>
          </div>
        ))}
      </div>

      {/* old code */}
      {/* <section className="Order_details_table Cart_Products_card ">
        <div className="table-responsive">
          <Table className="">
            <tbody>
              {order?.map((val) => (
                <tr>
                
                  <td>
                    <div className="row">
                      <div className="col-xl-2 col-lg-3 col-md-3 col-3">
                        <div className="img_holder">
                          <img
                            className="Product_img"
                            src={
                              getVariantImage(val)
                            }
                            alt={"Product_img"}
                          />
                        </div>
                      </div>
                      <div className=" col-xl-10 col-lg-9 col-md-9 col-9">
                        <div className="info_text_holder">
                          <div>
                            <h4>{val?.Product?.name}</h4>

                            <h6>
                              {val?.Product
                                ?.variant_type_id === variant_type.Single && (
                                <>
                                  <strong>
                                    {val?.Product
                                      ?.variant_name || "Color"}
                                    :
                                  </strong>{" "}
                                  {
                                    val?.Product_Variant
                                      ?.Metal?.name
                                  }
                                </>
                              )}

                              {val?.Product
                                ?.variant_type_id === variant_type.Double && (
                                <>
                                  <strong>
                                    {val?.Product
                                      ?.variant_name || "Color"}
                                    :
                                  </strong>{" "}
                                  {
                                    val?.Double_Variant
                                      ?.Product_Variant?.Metal?.name
                                  }
                                  , <strong>Size:</strong>{" "}
                                  {
                                    val?.Double_Variant
                                      ?.Size?.name
                                  }{" "}
                                </>
                              )}

                              {val?.Product
                                ?.variant_type_id === variant_type.Triple && (
                                <>
                                  <strong>Size:</strong>{" "}
                                  {
                                    val?.Triple_Variant
                                      ?.Double_Variant?.Product_Variant?.Metal
                                      ?.name
                                  }
                                  
                                  {
                                    val?.Triple_Variant
                                      ?.Double_Variant?.Size?.name
                                  }
                                 
                                  {
                                    val?.Triple_Variant
                                      ?.Diamond?.name
                                  }
                                </>
                              )}
                            </h6>
                          </div>
                        </div>
                      </div>
                      {val?.Product?.Rating_Reviews ===
                        null && (
                        <div className="mt-2">
                          <button
                            className="btn btn-success btn-sm"
                            onClick={() => handleOpenReview(val)}
                          >
                            Review & Rating
                          </button>
                        </div>
                      )}
                    </div>
                  </td>

                  <td>
                    <div className="Quantity_tr_holder">
                      <div className="price_holder">
                        <p className="mb-0" style={{ color: "#000" }}>
                          {allorder?.no_of_item ||1} * ₹
                          {allorder?.total_selling_price}
                        </p>
                      </div>
                    </div>
                    <div className="Quantity_tr_holder">
                      <div className="price_holder">
                        <p className="mb-0">
                          {" "}
                          Total: ₹{" "}
                          {allorder?.no_of_item ||1 *
                            allorder?.total_selling_price}
                        </p>
                      </div>
                    </div>
                  </td>
                </tr>
              ))}

             <tr >
                <td>
                  <div className="row">
                    <div className="col-xl-2 col-lg-3 col-md-3 col-3">
                      <div className="img_holder">
                        <img
                          className="Product_img"
                          src={
                            process.env.PUBLIC_URL +
                            "/assets/images/product/ghee.png"
                          }
                          alt={"Product_img"}
                        />
                      </div>
                    </div>
                    <div className=" col-xl-10 col-lg-9 col-md-9 col-9">
                      <div className="info_text_holder">
                        <div>
                          <h4>
                            Bilona Cow Ghee – Made from A2 Milk of Desi Cows
                          </h4>

                          <h6>
                            Size: <span>1L</span>
                          </h6>
                        </div>
                      </div>
                    </div>
                  </div>
                </td>

                <td>
                  <div className="Quantity_tr_holder">
                    <div className="price_holder">
                      <p className="mb-0">
                        <span>X 1</span> ₹400
                      </p>

                    </div>


                  </div>
                </td>
              </tr>

               <tr >
                <td>
                  <div className="row">
                    <div className="col-xl-2 col-lg-3 col-md-3 col-3">
                      <div className="img_holder">
                        <img
                          className="Product_img"
                          src={
                            process.env.PUBLIC_URL +
                            "/assets/images/product/ghee.png"
                          }
                          alt={"Product_img"}
                        />
                      </div>
                    </div>
                    <div className=" col-xl-10 col-lg-9 col-md-9 col-9">
                      <div className="info_text_holder">
                        <div>
                          <h4>
                            Bilona Cow Ghee – Made from A2 Milk of Desi Cows
                          </h4>

                          <h6>
                            Size: <span>1L</span>
                          </h6>
                        </div>
                      </div>
                    </div>
                  </div>
                </td>

                <td>
                  <div className="Quantity_tr_holder">
                    <div className="price_holder">
                      <p className="mb-0">
                        <span>X 1</span> ₹400
                      </p>

                    </div>


                  </div>
                </td>
              </tr>

              <tr >
                <td>
                  <div className="row">
                    <div className="col-xl-2 col-lg-3 col-md-3 col-3">
                      <div className="img_holder">
                        <img
                          className="Product_img"
                          src={
                            process.env.PUBLIC_URL +
                            "/assets/images/product/ghee.png"
                          }
                          alt={"Product_img"}
                        />
                      </div>
                    </div>
                    <div className=" col-xl-10 col-lg-9 col-md-9 col-9">
                      <div className="info_text_holder">
                        <div>
                          <h4>
                            Bilona Cow Ghee – Made from A2 Milk of Desi Cows
                          </h4>

                          <h6>
                            Size: <span>1L</span>
                          </h6>
                        </div>
                      </div>
                    </div>
                  </div>
                </td>

                <td>
                  <div className="Quantity_tr_holder">
                    <div className="price_holder">
                      <p className="mb-0">
                        <span>X 1</span> ₹400
                      </p>

                    </div>


                  </div>
                </td>
              </tr> 
            </tbody>
          </Table>
        </div>
      </section> */}
    </>
  );
}

export default Replace_Order_details_table;
